import {http} from "Services/Http/HttpClient";

export interface CreateBankSwiftCodeBody {
    id: string;
    bic: string;
    bank: string;
}

export interface UpdateBankSwiftCodeBody {
    bic: string;
    bank: string;
}

export const createBankSwiftCode = (body: CreateBankSwiftCodeBody) =>
    http.post('/bank-swift-codes', body);

export const updateBankSwiftCode = (id: string, body: UpdateBankSwiftCodeBody) =>
    http.patch('/bank-swift-codes/' + id, body);

export const deleteBankSwiftCodes = (ids: string[]) =>
    http.delete('/bank-swift-codes', {data: {ids}});
